import { useEffect, useState, type ReactNode } from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { i18nService } from '../../services/i18n';

/** 过程段和工具序列共用的纯展示折叠器；调用方用稳定消息 ID 作为 React key。 */
interface ConversationActivityDisclosureProps {
  kind: 'process' | 'sequence';
  /** 工具序列当前项的摘要；过程段使用统一国际化标题。 */
  label?: string;
  toolCount: number;
  running?: boolean;
  /** 非零值表示新的搜索定位请求，定位后用户仍可手动收起。 */
  searchFocus?: number;
  children: ReactNode;
}

/** 只响应用户选择和新搜索；流式增量、当前工具变化不会重置折叠状态。 */
export default function ConversationActivityDisclosure({
  kind, label, toolCount, running = false, searchFocus = 0, children,
}: ConversationActivityDisclosureProps) {
  const [expanded, setExpanded] = useState(false);
  useEffect(() => { if (searchFocus) setExpanded(true); }, [searchFocus]);
  const title = kind === 'process' ? i18nService.t('coworkExecutionProcess') : label;
  return (
    <section data-cowork-activity={kind}>
      <button type="button" onClick={() => setExpanded(value => !value)} aria-expanded={expanded}
        title={title} className="flex w-full min-w-0 items-center gap-2 py-1 text-left text-xs dark:text-claude-darkTextSecondary text-claude-textSecondary">
        <ChevronRightIcon className={`h-3.5 w-3.5 shrink-0 transition-transform ${expanded ? 'rotate-90' : ''}`} />
        {running && <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-claude-accent animate-pulse" />}
        <span className="min-w-0 truncate">{title}</span>
        {toolCount > 0 && <span className="shrink-0 opacity-60">{i18nService.t('coworkToolSequenceCount').replace('{count}', String(toolCount))}</span>}
      </button>
      {expanded && <div className="mt-2 space-y-3">{children}</div>}
    </section>
  );
}
